import script from "./ListVouchers.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListVouchers.vue?vue&type=script&lang=ts&setup=true"

import "./ListVouchers.vue?vue&type=style&index=0&id=ce740a3a&lang=css"

export default script